<div class="skeleton h-[180px] w-full"></div>
<div class="skeleton my-2 h-4 w-28"></div>
<div class="skeleton h-4 w-full"></div>
